<script>
    import FormStatusMixin from "../../../author/pagesbuilder/mixins/FormStatusMixin";

    export default {
        name: "ContactFormWrapperElement",
        mixins: [
            FormStatusMixin
        ],
        data() {
            return {
                givesContextToChildren: true,
                elementType: 'contact-form-wrapper',
            }
        }
    }
</script>